module.exports = __webpack_public_path__ + "img/icon_plus_gray.94825c8c.svg";